module.exports = __webpack_public_path__ + "static/img/revenue-top3.d837279a.png";